import styled, { createGlobalStyle } from 'styled-components';

import { space3XL, spaceXXL } from '@xing-com/tokens';

export const MODAL_WRAPPER_CLASS_NAME = 'link-share-modal-page-wrapper';

export const ModalWrapperGlobalStyles = createGlobalStyle`
  .${MODAL_WRAPPER_CLASS_NAME} {
    margin: 0;
  }
`;

export const LinkShareModalContainer = styled.div`
  overflow-y: auto;
  padding: ${spaceXXL} ${space3XL};
  height: 100vh;
`;
